import { createContext, ReactNode, useContext } from 'react'
import { Alert } from '@/ui'
import type { IUnresolvedDocument } from '../../hooks/use-document-eligibility'

const DocumentValidationContext = createContext(false)

export const DocumentValidationProvider = ({
  showErrors,
  children,
}: {
  showErrors: boolean
  children: ReactNode
}) => (
  <DocumentValidationContext.Provider value={showErrors}>
    {children}
  </DocumentValidationContext.Provider>
)

export const useShowDocumentErrors = () => useContext(DocumentValidationContext)

export const DocumentsValidationAlert = ({
  unresolvedDocuments,
}: {
  unresolvedDocuments: IUnresolvedDocument[]
}) => {
  const showErrors = useShowDocumentErrors()

  if (!showErrors || unresolvedDocuments.length === 0) return null

  const labels = (canMarkNotRelevant: boolean) =>
    unresolvedDocuments
      .filter((doc) => doc.canMarkNotRelevant === canMarkNotRelevant)
      .map((doc) => doc.label)
      .join(', ')

  const notRelevantAllowed = labels(true)
  const uploadOnly = labels(false)
  const description = [
    notRelevantAllowed &&
      `Upload each document or mark it "Not relevant": ${notRelevantAllowed}.`,
    uploadOnly && `Upload: ${uploadOnly}.`,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Alert
      className="mt-4"
      variant="error"
      title="Resolve these documents to continue"
      description={description}
    />
  )
}
